var _linearGradient, _linearGradient2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPython = function SvgPython(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 110.421,
    height: 109.846
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffe052",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffc331",
      stopOpacity: 1
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "d",
    x1: 89.137,
    x2: 147.777,
    y1: 111.921,
    y2: 168.101,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#387eb8",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#366994",
      stopOpacity: 1
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "c",
    x1: 55.549,
    x2: 110.149,
    y1: 77.07,
    y2: 131.853,
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M99.75 67.469c-28.032 0-26.281 12.156-26.281 12.156l.031 12.594h26.75V96H62.875s-17.937-2.034-17.937 26.25 15.656 27.281 15.656 27.281h9.343v-13.125s-.503-15.656 15.407-15.656h26.531s14.906.241 14.906-14.406V82.125s2.263-14.656-27.031-14.656M85 75.938a4.81 4.81 0 0 1 4.813 4.812A4.81 4.81 0 0 1 85 85.563a4.81 4.81 0 0 1-4.812-4.813A4.81 4.81 0 0 1 85 75.938",
    style: {
      opacity: 1,
      color: "#000",
      fill: "url(#c)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    transform: "translate(-44.938 -67.469)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.546 177.315c28.032 0 26.281-12.156 26.281-12.156l-.03-12.594h-26.75v-3.781h37.374s17.938 2.034 17.938-26.25c0-28.285-15.657-27.282-15.657-27.282h-9.343v13.125s.503 15.657-15.407 15.657h-26.53s-14.907-.241-14.907 14.406v24.219s-2.263 14.656 27.031 14.656m14.75-8.469a4.81 4.81 0 0 1-4.812-4.812 4.81 4.81 0 0 1 4.812-4.813 4.81 4.81 0 0 1 4.813 4.813 4.81 4.81 0 0 1-4.813 4.812",
    style: {
      opacity: 1,
      color: "#000",
      fill: "url(#d)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    transform: "translate(-44.938 -67.469)"
  }));
};
export { SvgPython as ReactComponent };
export default "/_next/static/chunks/svg/python-063da19947a3fcdbfd9437a744e8d745.svg";